<div class="chat">
  <app-chat class="nb-theme-dark" [id]="roomId"></app-chat>
</div>

<!-- Archive button -->
<button #archiveButton class="archive-menu-button" [matMenuTriggerFor]="archiveMenu" type="button">
  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
</button>

<!-- Archive menu -->
<mat-menu #archiveMenu="matMenu" xPosition="before" class="archive-chat-menu">
  <button mat-menu-item (click)="archiveChat()">
    <i class="fa fa-archive" aria-hidden="true"></i>
    <span>{{ "CHAT.ARCHIVE" | translate }}</span>
  </button>
</mat-menu>